import { createFileRoute, Outlet } from '@tanstack/react-router';

import { OrganizationSettingsLayout } from '@/areas/settings/OrganizationSettings/OrganizationSettingsLayout';
import type { PageStaticData } from '@/shared/routing';

// Keeps the menu and its scroll position across pages.
// Pathless: account security sits at `/settings/user`, and pages without the menu sit beside the ones with it.
export const Route = createFileRoute('/_authenticated/settings/_menu')({
    // The access every page shares; each page declares its own as well.
    staticData: { access: { permissions: ['view:organization_settings'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <OrganizationSettingsLayout>
            <Outlet />
        </OrganizationSettingsLayout>
    );
}
